module.exports = __webpack_public_path__ + "static/media/27OCHA9.4853baec.jpg";